import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { AdminAPIs } from "../network/adminApiServices";
import { AuthAPIs } from "../network/authApiService";
import { BulkAPIs } from "../network/bulkUploadApiServices";
import { ChatAPIs } from "../network/chatApiServices";
import { HelpAPIs } from "../network/helpApiServices";
import { MaintenanceAPIs } from "../network/maintenanceApiService";
import { MapAPIs } from "../network/mapApiServices";
import { NotificationAPIs } from "../network/notificationApiServices";
import { ReportAPIs } from "../network/reportApiServices";
import { SchedulerAPIs } from "../network/schedularApi";
import { SysadminAPIs } from "../network/sysadminApiServices";
import { UserAPIs } from "../network/userApiService";
import { WeatherApis } from "../network/weatherApiServices";
import { OverviewAPIs } from "../network/overviewApiServices";
import commonSlice from "./commonSlice";
import { VMAdminAPIs } from "../network/vmApiService";
import { CamerasAdminVMAPIs } from "../network/camerasAdminVMApiService";
import { IncidentAPIs } from "../network/incidentApiServices";
import { InCabAPIs } from "../network/incabApiServices";

// ...

export const store = configureStore({
  reducer: {
    [AuthAPIs.reducerPath]: AuthAPIs.reducer,
    [UserAPIs.reducerPath]: UserAPIs.reducer,
    [AdminAPIs.reducerPath]: AdminAPIs.reducer,
    [SysadminAPIs.reducerPath]: SysadminAPIs.reducer,
    [MapAPIs.reducerPath]: MapAPIs.reducer,
    [WeatherApis.reducerPath]: WeatherApis.reducer,
    [ReportAPIs.reducerPath]: ReportAPIs.reducer,
    [MaintenanceAPIs.reducerPath]: MaintenanceAPIs.reducer,
    [NotificationAPIs.reducerPath]: NotificationAPIs.reducer,
    [BulkAPIs.reducerPath]: BulkAPIs.reducer,
    [SchedulerAPIs.reducerPath]: SchedulerAPIs.reducer,
    [HelpAPIs.reducerPath]: HelpAPIs.reducer,
    [ChatAPIs.reducerPath]: ChatAPIs.reducer,
    [OverviewAPIs.reducerPath]: OverviewAPIs.reducer,
    [VMAdminAPIs.reducerPath]: VMAdminAPIs.reducer,
    [CamerasAdminVMAPIs.reducerPath]: CamerasAdminVMAPIs.reducer,
    [IncidentAPIs.reducerPath]: IncidentAPIs.reducer,
    [InCabAPIs.reducerPath]: InCabAPIs.reducer,
    commonReducer: commonSlice,
  },

  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      AuthAPIs.middleware,
      UserAPIs.middleware,
      AdminAPIs.middleware,
      SysadminAPIs.middleware,
      MapAPIs.middleware,
      WeatherApis.middleware,
      ReportAPIs.middleware,
      MaintenanceAPIs.middleware,
      NotificationAPIs.middleware,
      BulkAPIs.middleware,
      SchedulerAPIs.middleware,
      HelpAPIs.middleware,
      ChatAPIs.middleware,
      OverviewAPIs.middleware,
      VMAdminAPIs.middleware,
      CamerasAdminVMAPIs.middleware,
      IncidentAPIs.middleware,
      InCabAPIs.middleware
    ),
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
